<div id="demographics" class="registration container">
  <form #demographicsForm="ngForm" [ngClass]="{'form-complete': demographicsForm.valid }"
    (ngSubmit)="forward(demographicsForm)" novalidate autocomplete="off" appScrollToInvalid
    [ngClass]="{'form-complete': isFormCompleted}">
    <h1>{{ 'copy.label.DEMOGRAPHICS.heading' | copy | async }}</h1>
    <section class="card">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.DEMOGRAPHICS.subheading' | copy | async }}
        </div>
      </div>

      <article>
        <div class="card-body w-100">

          <div class="w-100 required">
            <label class="w-100 font-weight-bold" for="firstTime"
              aria-labelledby="firstTime">{{'copy.label.DEMOGRAPHICS.firsttime'|copy|async}}</label>
            <mat-radio-group class="w-100" [(ngModel)]="firstTime.Value" name="firstTime" required >
              <mat-radio-button value="Yes">Yes</mat-radio-button>
              <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>
          </div>
          <div>{{'copy.label.DEMOGRAPHICS.describeyou'|copy|async}}</div>
          <mat-form-field class="w-100 required">
            <mat-label class="w-100 font-weight-bold" for="age1"
              aria-labelledby="firstTime">{{'copy.label.DEMOGRAPHICS.selectOne'|copy|async}}</mat-label>
            <mat-select class="w-100" [(ngModel)]="age.Value" name="age1" required matNativeControl>
              <mat-option value="18-24 years of age">18-24 years of age</mat-option>
              <mat-option value="25-34 years of age">25-34 years of age</mat-option>
              <mat-option value="35-44 years of age">35-44 years of age</mat-option>
              <mat-option value="45-54 years of age">45-54 years of age</mat-option>
              <mat-option value="55-64 years of age">55-64 years of age</mat-option>
              <mat-option value="65 or older">65 or older</mat-option>
              <mat-option value="Prefer not to answer">Prefer not to answer</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="w-100 required">
            <mat-label class="w-100 font-weight-bold" for="gender"
              aria-labelledby="gender">{{'copy.label.DEMOGRAPHICS.selectOne'|copy|async}}</mat-label>
            <mat-select class="w-100" [(ngModel)]="gender.Value" name="gender" required matNativeControl>
              <mat-option value="Male">Male</mat-option>
              <mat-option value="Female">Female</mat-option>
              <mat-option value="Other">Other</mat-option>
              <mat-option value="Prefer not to answer">Prefer not to answer</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="w-100 required" *ngIf="gender.Value == 'Other'">
            <mat-label class="w-100 font-weight-bold" for="othergender"
              aria-labelledby="othergender">{{'copy.label.DEMOGRAPHICS.other'|copy|async}}</mat-label>
            <input matInput class="w-100" [(ngModel)]="enrollment.$mtcOtherGender" name="othergender" required />
          </mat-form-field>

          <mat-form-field class="w-100 required">
            <mat-label class="w-100 font-weight-bold" for="ethnicity"
              aria-labelledby="ethnicity">{{'copy.label.DEMOGRAPHICS.selectOne'|copy|async}}</mat-label>
            <mat-select class="w-100" [(ngModel)]="ethnicity.Value" name="ethnicity" required matNativeControl>
              <mat-option value="White">White</mat-option>
              <mat-option value="Black or African American">Black or African American</mat-option>
              <mat-option value="American Indian or Alaskan Native">American Indian or Alaskan Native</mat-option>
              <mat-option value="Asian">Asian</mat-option>
              <mat-option value="Native Hawaiian or other Pacific Islander">Native Hawaiian or other Pacific
                Islander</mat-option>
              <mat-option value="From multiple races">From multiple races</mat-option>
              <mat-option value="Other">Other</mat-option>
              <mat-option value="Prefer not to answer">Prefer not to answer</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="w-100 required" *ngIf="ethnicity.Value == 'Other'">
            <mat-label class="w-100 font-weight-bold" for="othereth"
              aria-labelledby="othereth">{{'copy.label.DEMOGRAPHICS.other'|copy|async}}</mat-label>
            <input matInput class="w-100" [(ngModel)]="enrollment.$mtcOtherEthnicity" name="othereth" required />
          </mat-form-field>


          <div>{{'copy.label.DEMOGRAPHICS.describebiz'|copy|async}}</div>
          <mat-form-field class="w-100 required">
            <mat-label class="w-100 font-weight-bold" for="bizjob"
              aria-labelledby="bizjob">{{'copy.label.DEMOGRAPHICS.selectOne'|copy|async}}</mat-label>
            <mat-select class="w-100" [(ngModel)]="bizjob.Value" name="bizjob" required matNativeControl>
              <mat-option value="Producing Advisor - Solo Practice">Producing Advisor - Solo Practice</mat-option>
              <mat-option value="Producing Advisor - Ensemble Team">Producing Advisor - Ensemble Team</mat-option>
              <mat-option value="OSJ/Enterprise Leader">OSJ/Enterprise Leader</mat-option>
              <mat-option value="Program Manager">Program Manager</mat-option>
              <mat-option value="Paraplanner">Paraplanner</mat-option>
              <mat-option value="Operations/Service Lead">Operations/Service Lead</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="w-100 required">
            <mat-label class="w-100 font-weight-bold" for="employeenums"
              aria-labelledby="employeenums">{{'copy.label.DEMOGRAPHICS.selectOne'|copy|async}}</mat-label>
            <mat-select class="w-100" [(ngModel)]="employeenums.Value" name="employeenums" required matNativeControl>
              <mat-option value="1-10 employees at my business">1-10 employees at my business</mat-option>
              <mat-option value="11-50 employees at my business">11-50 employees at my business</mat-option>
              <mat-option value="51-100 employees at my business">51-100 employees at my business</mat-option>
              <mat-option value="101-500 employees at my business">101-500 employees at my business</mat-option>
              <mat-option value="501 or more employees at my business">501 or more employees at my business</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="w-100 required">
            <mat-label class="w-100 font-weight-bold" for="exp"
              aria-labelledby="exp">{{'copy.label.DEMOGRAPHICS.selectOne'|copy|async}}</mat-label>
            <mat-select class="w-100" [(ngModel)]="exp.Value" name="exp" required matNativeControl>
              <mat-option value="Less than 1 year of financial experience">Less than 1 year of financial
                experience</mat-option>
              <mat-option value="1-5 years of financial experience">1-5 years of financial experience</mat-option>
              <mat-option value="6-10 years of financial experience">6-10 years of financial experience</mat-option>
              <mat-option value="11-15 years of financial experience">11-15 years of financial experience</mat-option>
              <mat-option value="More than 15 years of financial experience">More than 15 years of financial
                experience</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="w-100 required">
            <mat-label class="w-100 font-weight-bold" for="aum"
              aria-labelledby="aum">{{'copy.label.DEMOGRAPHICS.selectOne'|copy|async}}</mat-label>
            <mat-select class="w-100" [(ngModel)]="aum.Value" name="aum" required matNativeControl>
              <mat-option value="$0-9M average AUM">$0-9M average AUM</mat-option>
              <mat-option value="$10-24M average AUM">$10-24M average AUM</mat-option>
              <mat-option value="$25-49M average AUM">$25-49M average AUM</mat-option>
              <mat-option value="$50-99M average AUM">$50-99M average AUM</mat-option>
              <mat-option value="$100+M average AUM">$100+M average AUM</mat-option>
            </mat-select>
          </mat-form-field>


          <mat-form-field class="w-100 required">
            <mat-label class="w-100 font-weight-bold" for="affiliation"
              aria-labelledby="affiliation">{{'copy.label.DEMOGRAPHICS.affiliation'|copy|async}}</mat-label>
            <mat-select class="w-100" [(ngModel)]="affiliation.Value" name="affiliation" required matNativeControl>
              <mat-option value="Independent">Independent</mat-option>
              <mat-option value="Institution (Bank or Credit Union)">Institution (Bank or Credit Union)</mat-option>
              <mat-option value="RIA">RIA</mat-option>
              <mat-option value="Hybrid (Independent & Institution)">Hybrid (Independent & Institution)</mat-option>
            </mat-select>
          </mat-form-field>


          <div class="w-100">
            <label class="font-weight-bold">{{'copy.label.DEMOGRAPHICS.is' | copy | async }}</label>
            <div class="checkbox-group">
              <div class="agreeCheckbox mt-2">
                <div class="checkboxFlexContainer">
                  <mat-checkbox [checked]="isalt.Value==='Yes'" (change)="checkToggle($event,isalt)" name="isalt"
                    class="example-margin">
                  </mat-checkbox>
                  <label>Alternative Investments</label>
                </div>
                <div class="checkboxFlexContainer">
                  <mat-checkbox [checked]="isbuf.Value==='Yes'" (change)="checkToggle($event,isbuf)" name="isbuf"
                    class="example-margin">
                  </mat-checkbox>
                  <label>Buffered Products</label>
                </div>
                <div class="checkboxFlexContainer">
                  <mat-checkbox [checked]="isemp.Value==='Yes'" (change)="checkToggle($event,isemp)" name="isemp"
                    class="example-margin">
                  </mat-checkbox>
                  <label>Employer Retirement Plans</label>
                </div>
                <div class="checkboxFlexContainer">
                  <mat-checkbox [checked]="isetf.Value==='Yes'" (change)="checkToggle($event,isetf)" name="isetf"
                    class="example-margin">
                  </mat-checkbox>
                  <label>ETFs</label>
                </div>
                <div class="checkboxFlexContainer">
                  <mat-checkbox [checked]="isnet.Value==='Yes'" (change)="checkToggle($event,isnet)" name="isnet"
                    class="example-margin">
                  </mat-checkbox>
                  <label>High Net Worth</label>
                </div>
                <div class="checkboxFlexContainer">
                  <mat-checkbox [checked]="ismodel.Value==='Yes'" (change)="checkToggle($event,ismodel)" name="ismodel"
                    class="example-margin">
                  </mat-checkbox>
                  <label>Models</label>
                </div>
                <div class="checkboxFlexContainer">
                  <mat-checkbox [checked]="issma.Value==='Yes'" (change)="checkToggle($event,issma)" name="issma"
                    class="example-margin">
                  </mat-checkbox>
                  <label>SMAs</label>
                </div>
              </div>
            </div>
          </div>

          <mat-form-field class="w-100 required" *ngIf="isalt.Value == 'Yes'">
            <mat-label class="w-100 font-weight-bold" for="aiv"
              aria-labelledby="aiv">{{'copy.label.DEMOGRAPHICS.AIV'|copy|async}}</mat-label>
            <input matInput class="w-100" [(ngModel)]="aiv.Value" name="aiv" required [maxLength]="100" />
          </mat-form-field>

          <mat-form-field class="w-100 required" *ngIf="issma.Value == 'Yes'">
            <mat-label class="w-100 font-weight-bold" for="sma"
              aria-labelledby="sma">{{'copy.label.DEMOGRAPHICS.SMA'|copy|async}}</mat-label>
            <input matInput class="w-100" [(ngModel)]="sma.Value" name="sma" required [maxLength]="100" />
          </mat-form-field>
        </div>
      </article>
    </section>
    <section class="card">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.DEMOGRAPHICS.commheading' | copy | async }}
        </div>
      </div>

      <article>
        <div class="card-body w-100">

          <div class="w-100 required">
            <label class="w-100 font-weight-bold" for="ce"
              aria-labelledby="ce">{{'copy.label.DEMOGRAPHICS.ce'|copy|async}}</label>
            <mat-radio-group class="w-100" [(ngModel)]="ce.Value" name="ce" required>
              <mat-radio-button value="Yes">Yes</mat-radio-button>
              <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>
          </div>

          <!-- <div class="w-100 required">
            <label class="w-100 font-weight-bold" for="dccontact"
              aria-labelledby="dccontact">{{'copy.label.DEMOGRAPHICS.dccontact'|copy|async}}</label>
            <mat-radio-group class="w-100" [(ngModel)]="dccontact.Value" name="dccontact" required>
              <mat-radio-button value="Email">Email</mat-radio-button>
              <mat-radio-button value="Phone Call">Phone Call</mat-radio-button>
              <mat-radio-button value="In-Person Meeting">In-Person Meeting</mat-radio-button>
            </mat-radio-group>
          </div> -->
          
          <mat-form-field class="w-100 required">
            <mat-label class="w-100 font-weight-bold" for="dccontact"
              aria-labelledby="dccontact">{{'copy.label.DEMOGRAPHICS.dccontact'|copy|async}}</mat-label>
            <mat-select class="w-100" [(ngModel)]="dccontact.Value" name="dccontact" required matNativeControl>
              <mat-option value="Email">Email</mat-option>
              <mat-option value="Phone Call">Phone Call</mat-option>
              <mat-option value="In-Person Meeting">In-Person Meeting</mat-option>

            </mat-select>
          </mat-form-field>

        </div>
      </article>
    </section>
    <section class="card" *ngIf="attendee.PAXTypeNo === 1 || attendee.PAXTypeNo === 2 || attendee.PAXTypeNo === 3">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.DEMOGRAPHICS.braindateheading' | copy | async }}
        </div>
      </div>

      <article>
        <div class="card-body w-100">

          <div class="w-100 required">
            <label class="w-100 font-weight-bold" for="braindate"
              aria-labelledby="braindate">Are you interested in being a Braindate ambassador at the conference? 
              <i>Braindate ambassadors are contributors within the community who lead peer sharing conversations with others in the Braindate Lounge during the conference.</i>
          </label>
           <mat-radio-group class="w-100" [(ngModel)]="braindate.Value" name="braindate" required>
              <mat-radio-button value="Yes">Yes</mat-radio-button>
              <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </article>
    </section>
    <div class="button_group d-flex">
      <button id="back-button" type="button" class="back btn btn-outline-primary" (click)="back()"
        *ngIf="!isSubmitting">
        {{ 'copy.label.GLOBAL.goback' | copy | async }}
      </button>
      <button id="forward-button" type="submit" class="inputSubmit btn btn-primary" *ngIf="!isSubmitting">
        {{ 'copy.label.GLOBAL.continue' | copy | async }}
      </button>
      <button class="inputSubmit btn btn-primary ml-auto" *ngIf="isSubmitting">
        <i class="fas fa-spinner fa-spin"></i>
      </button>
    </div>
  </form>
</div>